import { cn } from "@/shared/lib/utils";
import type { FeatureFlagValueType } from "./types";

const TYPE_STYLES: Record<FeatureFlagValueType, string> = {
  BOOLEAN: "bg-emerald-500/15 text-emerald-600 border-emerald-500/30",
  STRING: "bg-sky-500/15 text-sky-700 border-sky-500/30",
  NUMBER: "bg-violet-500/15 text-violet-700 border-violet-500/30",
  JSON: "bg-amber-500/15 text-amber-700 border-amber-500/30",
};

interface FeatureFlagTypeBadgeProps {
  readonly valueType: FeatureFlagValueType;
}

export function FeatureFlagTypeBadge({ valueType }: FeatureFlagTypeBadgeProps) {
  return (
    <span
      data-testid={`feature-flag-type-${valueType}`}
      className={cn(
        "inline-flex items-center rounded-full border px-2 py-0.5 font-mono text-[10px] font-semibold tracking-wide",
        TYPE_STYLES[valueType],
      )}
    >
      {valueType}
    </span>
  );
}
